import React, { useRef, useEffect } from 'react';
import { createPortal } from 'react-dom';

const HeaderContextMenu = ({ x, y, onClose, onPin, isPinned }) => {
  const menuRef = useRef(null);

  // Adjust position to stay within viewport
  useEffect(() => {
    if (menuRef.current) {
      const rect = menuRef.current.getBoundingClientRect();
      const viewportWidth = window.innerWidth;
      const viewportHeight = window.innerHeight;

      // Adjust horizontal position if menu would go off-screen
      if (rect.right > viewportWidth) {
        menuRef.current.style.left = 'auto';
        menuRef.current.style.right = '0';
      }

      // Adjust vertical position if menu would go off-screen
      if (rect.bottom > viewportHeight) {
        menuRef.current.style.top = 'auto';
        menuRef.current.style.bottom = '0';
      }
    }
  }, [x, y]);

  const handlePin = (e) => {
    e.preventDefault();
    onPin();
    onClose();
  };

  return createPortal(
    <div 
      ref={menuRef}
      className="fixed bg-white shadow-lg rounded-md py-1 z-[100] min-w-[160px] border border-gray-200 context-menu"
      style={{ 
        top: `${y}px`, 
        left: `${x}px`,
      }}
    >
      <button
        className="w-full px-4 py-2 text-left text-sm hover:bg-gray-100 flex items-center space-x-2"
        onClick={handlePin}
      >
        <span>{isPinned ? 'Unpin Column' : 'Pin Column'}</span>
      </button>
    </div>,
    document.body
  );
};

export default HeaderContextMenu;
